module.exports = __webpack_public_path__ + "static/media/sermos_white_RGB.812dc25e.png";